import { $Qll } from '../utils/querySelector';
import Swiper, { Navigation, Pagination, FreeMode, Autoplay, Thumbs } from 'swiper';
import 'swiper/css';

const configArrows = (id) => {
  new Swiper(id, {
    modules: [Navigation, FreeMode],
    slidesPerView: 'auto',
    spaceBetween: 25,
    navigation: {
      nextEl: `.swiper-button-next[data-id="${id.substr(1)}"]`,
      prevEl: `.swiper-button-prev[data-id="${id.substr(1)}"]`,
    },
    freeMode: true,
    breakpoints: {
      720: {
        slidesPerView: 2,
        spaceBetween: 28,
        freeMode: false,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 28,
        freeMode: false,
      },
    },
  });
};

export const configPagination = (id) => {
  new Swiper(id, {
    modules: [Pagination, FreeMode],
    slidesPerView: 'auto',
    spaceBetween: 25,
    pagination: {
      el: `.swiper-custom-pagination[data-id="${id.substr(1)}"]`,
      clickable: true,
    },
    freeMode: true,
    breakpoints: {
      720: {
        slidesPerView: 2,
        spaceBetween: 28,
        freeMode: false,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 28,
        freeMode: false,
      },
    },
  });
};

export const configPaginationArrows = (id) => {
  new Swiper(id, {
    modules: [Pagination, FreeMode, Navigation],
    slidesPerView: 'auto',
    spaceBetween: 25,
    navigation: {
      nextEl: `.swiper-button-next[data-id="${id.substr(1)}"]`,
      prevEl: `.swiper-button-prev[data-id="${id.substr(1)}"]`,
    },
    pagination: {
      el: `.swiper-custom-pagination[data-id="${id.substr(1)}"]`,
      clickable: true,
    },
    freeMode: true,
    breakpoints: {
      720: {
        slidesPerView: 2,
        spaceBetween: 28,
        freeMode: false,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 28,
        freeMode: false,
      },
    },
  });
};

export const configProductCard = (id) => {
  new Swiper(id, {
    modules: [Pagination, FreeMode],
    slidesPerView: 'auto',
    spaceBetween: 25,
    pagination: {
      el: `.swiper-pagination[data-id="${id.substr(1)}"]`,
      clickable: true,
    },
    freeMode: true,
    breakpoints: {
      720: {
        slidesPerView: 2,
        spaceBetween: 28,
        freeMode: false,
        pagination: false,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 28,
        freeMode: false,
        pagination: false,
      },
    },
  });
};

export const configProductSimilar = (id, perView) => {
  new Swiper(id, {
    modules: [FreeMode, Navigation],
    slidesPerView: 1.7,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    freeMode: true,
    breakpoints: {
      720: {
        slidesPerView: perView,
        spaceBetween: 16,
        freeMode: false,
      }
    },
  });
};

export const swiperSmall = new Swiper('.slider_small', {
  modules: [Pagination, Autoplay, FreeMode],
  slidesPerView: 1,
  spaceBetween: 25,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  freeMode: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});

export const productSwiperSmal = new Swiper('.product-slider', {
  modules: [Pagination, Autoplay, FreeMode, Navigation],
  slidesPerView: 1,
  spaceBetween: 25,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

export const swiperArrows = (() => {
  $Qll('.slider_arrows').map((slide) => {
    configArrows('#' + slide.id);
  });
})();

export const swiperPagination = (() => {
  $Qll('.slider_pagination').map((slide) => {
    configPagination('#' + slide.id);
  });
})();

export const swiperProductCard = (() => {
  $Qll('.product_card').map((slide) => {
    configProductCard('#' + slide.id);
  });
})();

export const swiperDualNavigation = (() => {
  $Qll('.slider_arrows_pagination').map((slide) => {
    configPaginationArrows('#' + slide.id);
  });
})();

export const swiperProductSimilar = (() => {
  $Qll('.similar-products__slider').map((slide) => {
    const perView = slide.getAttribute('data-view');
    configProductSimilar('#' + slide.id, perView);
  });
})();
